import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AccountService } from '@http/clients/account.service';
import { AccountView, QuickSearchAccountParameters } from '@http/clients/api-proxies';
import { GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { createValueAccessorProvider, FormEditorBase } from '../base/form-editor-base';
@Component({
    selector: 'app-account-form-editor',
    templateUrl: './account-form-editor.component.html',
    styleUrls: ['./account-form-editor.component.scss'],
    providers: [createValueAccessorProvider(AccountFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent]
})
export class AccountFormEditorComponent extends FormEditorBase<AccountView[]> implements OnInit {
    // Inputs como signals
    value = input<AccountView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Accounts');

    private readonly accountService = inject(AccountService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadAccounts();
    }
    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }
        const accounts = await this.accountService.search({
            filterText: text,
            organizationId: undefined,
            isActive: true
        } as QuickSearchAccountParameters);
        this.items.set(accounts);
    }
    protected override mapSelectedItemsToValue(): AccountView[] {
        return this.selectedItems() || [];
    }
    protected override mapValueToSelectedItems(value: AccountView[]): any[] {
        return value || [];
    }
    private async loadAccounts(): Promise<void> {
        this.items.set([]);
    }
}
